// extracted by mini-css-extract-plugin
export var chevron = "_2f-2";
export var chevronCollapsed = "_2f-3";
export var collapsibleHeader = "_2f-1";
export var container = "_2f-0";